"use client";
import React, { useEffect } from 'react';
import { createContext, useState } from 'react';
import { getUserTokenFromPath } from '../utils';
import { useCreateCustomer, useFetchCustomer } from '../service/customer';


type TProps = {
  config: any;
  children: any
}

type TAppState = {
  waiting: boolean;
  userToken: null | string;
  createNewChat: (val: any) => void;
  chatIsInitiated: boolean;
}

export const UserManagementContext = createContext<TAppState>({
  waiting: false,
  userToken: null,
  createNewChat: (val: any) => {console.log('createNewChat is not implemented')},
  chatIsInitiated: false
});

export const UserManagementProvider = ({config, children}: TProps) => {
  const query = new URLSearchParams(location.search);
  const projectId = query.get('projectId');

  !!projectId && 
    (config.projectId = projectId)

  console.log('projectId', projectId)

  if(!config.projectId) {
    console.error("Please provide project Id in your config")
    return
  }
  const userTokenFromPath = getUserTokenFromPath();
  const [[fetched], fetchFn] = useFetchCustomer({campaignId: config.projectId});
  const [created, createFn] = useCreateCustomer({campaignId: config.projectId});
  const [userToken, setUserToken] = useState<null|string>(config.userToken || null);
  const [waiting, setWaiting] = useState(false);

  useEffect(() => {
    fetchFn()
  }, [])
    
  useEffect(() => {
    if(!userToken && !!userTokenFromPath) {
      setUserToken(userTokenFromPath);
    }
  }, [userToken, userTokenFromPath])

  useEffect(() => {
    const isExists = !!fetched?.exists;
    const hasProps = config?.initFormData && !!Object.keys(config.initFormData).length;

    if (isExists) {
      setUserToken(fetched.chatSessionId);
      setWaiting(false);
    } else if (fetched && hasProps) {
      createFn(config.initFormData);
    }
  }, [fetched, config.initFormData])

  useEffect(() => {
    //@ts-ignore
    if(!!created?.success) {
      //@ts-ignore
      setUserToken(created?.chatSessionId)
    }
    setWaiting(false);
  }, [created])

  const state = {
    waiting,
    userToken,
    createNewChat: createFn,
    chatIsInitiated: !!userToken
  };

  return (
    <UserManagementContext.Provider 
      value={state}
    >
      {children}
    </UserManagementContext.Provider>
  );
}

export default UserManagementProvider;